/**
 * ------------------------------------------------------------------
 * Love Leads The Way Podcast
 * ------------------------------------------------------------------
 * Temporary local resource data.
 *
 * Future Laravel API endpoint:
 *
 * GET /api/podcast/episodes
 *
 * Expected JSON structure:
 *
 * {
 *   guid,
 *   season,
 *   episode,
 *   title,
 *   published,
 *   duration,
 *   explicit,
 *   audioUrl,
 *   link,
 *   description
 * }
 *
 * ------------------------------------------------------------------
 */


export const podcastEpisodes = [

    {
        guid: "012a01b2-1e08-4525-ba07-beebccc0a6ab",
        season: 1,
        episode: 10,

        title:
            "From Loss to Light: A Story of Grief and Growth",

        published:
            "2025-06-30",

        duration:
            "01:04:08",

        explicit: false,

        audioUrl:
            "https://anchor.fm/s/eff13fac/podcast/play/104809307/https%3A%2F%2Fd3ctxlq1ktw2nl.cloudfront.net%2Fstaging%2F2025-5-30%2F403026403-44100-2-d4312c9f4c694.mp3",

        link:
            "https://podcasters.spotify.com/pod/show/felizgarcia/episodes/From-Loss-to-Light-A-Story-of-Grief-and-Growth-e34t1cr",

        description:
            "Stephanie Sena Dyck shares her deeply personal journey through grief, healing, health challenges, and the loss of her grandmother. This conversation explores vulnerability, authenticity, prayer, gratitude, and the healing power of community."
    },


    {
        guid: "0707f5e4-126e-41ae-a7c4-694f8fe1d448",
        season: 1,
        episode: 9,

        title:
            "Heart to Heart: The Power of Music and Faith with Carrie Aboytes",

        published:
            "2025-06-13",

        duration:
            "01:00:18",

        explicit: false,

        audioUrl:
            "https://anchor.fm/s/eff13fac/podcast/play/104057198/https%3A%2F%2Fd3ctxlq1ktw2nl.cloudfront.net%2Fstaging%2F2025-5-13%2F402072307-44100-2-e04e088ce832.mp3",

        link:
            "https://podcasters.spotify.com/pod/show/felizgarcia/episodes/Heart-to-Heart-The-Power-of-Music-and-Faith-with-Carrie-Aboytes-e3462te",

        description:
            "Feliz Garcia and Carrie Aboytes discuss faith, family challenges, prayer, music, and community. They explore healing, hope, personal growth, and the reminder that we are never truly alone."
    },


    {
        guid: "3be69118-202f-482d-b0a8-ae15d0ea2302",
        season: 1,
        episode: 8,

        title:
            "Prophesy Hope: Alicia Kowalski on Faith, Healing & Purpose",

        published:
            "2025-04-27",

        duration:
            "00:51:26",

        explicit: false,

        audioUrl:
            "https://anchor.fm/s/eff13fac/podcast/play/101829964/https%3A%2F%2Fd3ctxlq1ktw2nl.cloudfront.net%2Fstaging%2F2025-3-27%2F399146819-44100-2-f4221529f060e.mp3",

        link:
            "https://podcasters.spotify.com/pod/show/felizgarcia/episodes/Prophesy-Hope-Alicia-Kowalski-on-Faith--Healing--Purpose-e3223sc",

        description:
            "Alicia Kowalski shares her journey through faith, healing, trauma, ministry, and discovering purpose through suffering. The conversation explores miracles, hope, spiritual practices, and community."
    },


    {
        guid: "b6eb3d0f-7a70-4299-af14-7cae3a1da003",
        season: 1,
        episode: 7,

        title:
            "Transformative Wellness Journey with Isaac Velarde",

        published:
            "2025-01-11",

        duration:
            "00:55:26",

        explicit: true,

        audioUrl:
            "https://anchor.fm/s/eff13fac/podcast/play/96923367/https%3A%2F%2Fd3ctxlq1ktw2nl.cloudfront.net%2Fstaging%2F2025-0-24%2F393615660-44100-2-7b35a6400c482.mp3",

        link:
            "https://podcasters.spotify.com/pod/show/felizgarcia/episodes/Transformative-Wellness-Journey-with-Isaac-Velarde-e2tcc97",

        description:
            "Feliz Garcia and Isaac Velarde discuss health, nutrition, mindset, spirituality, trauma recovery, and the role of faith in personal transformation."
    },


    {
        guid: "eb7c5340-2d12-4827-9e59-7e4a465964a6",
        season: 1,
        episode: 6,

        title:
            "Embracing Life's Journey with Paul Martinez",

        published:
            "2024-12-16",

        duration:
            "01:11:01",

        explicit: false,

        audioUrl:
            "https://anchor.fm/s/eff13fac/podcast/play/95880320/https%3A%2F%2Fd3ctxlq1ktw2nl.cloudfront.net%2Fstaging%2F2024-11-16%2F391618681-44100-2-4e9dcafc89426.mp3",

        link:
            "https://podcasters.spotify.com/pod/show/felizgarcia/episodes/Embracing-Lifes-Journey-with-Paul-Martinez-e2schm0",

        description:
            "Feliz Garcia and Paul Martinez explore spiritual growth, prayer, parenthood, relationships, gratitude, communication, and listening to God's guidance."
    },


    {
        guid: "08ddf58c-e178-416a-b379-e09a5fe4622c",
        season: 1,
        episode: 5,

        title:
            "The Transformative Power of Music and Prayer with Frances Castellano",

        published:
            "2024-10-20",

        duration:
            "00:52:58",

        explicit: false,

        audioUrl:
            "https://anchor.fm/s/eff13fac/podcast/play/93307128/https%3A%2F%2Fd3ctxlq1ktw2nl.cloudfront.net%2Fstaging%2F2024-9-20%2F388429367-44100-2-4276032788dcd.mp3",

        link:
            "https://podcasters.spotify.com/pod/show/felizgarcia/episodes/The-Transformative-Power-of-Music-and-Prayer-with-Frances-Castellano-e2pu0po",

        description:
            "Frances Castellano shares her journey of faith, healing, music, prayer, kindness, community, and recognizing miracles in everyday life."
    },


    {
        guid: "be7431ff-a597-43b5-8969-174df1aa5385",
        season: 1,
        episode: 4,

        title:
            "Infinite Possibilities: Holistic Healing and Fertility with Elaine Lopez-Bogard",

        published:
            "2024-09-22",

        duration:
            "01:00:34",

        explicit: true,

        audioUrl:
            "https://anchor.fm/s/eff13fac/podcast/play/92050277/https%3A%2F%2Fd3ctxlq1ktw2nl.cloudfront.net%2Fstaging%2F2024-8-22%2F386834027-44100-2-e52a1e98cd1c6.mp3",

        link:
            "https://podcasters.spotify.com/pod/show/felizgarcia/episodes/Infinite-Possibilities-Holistic-Healing-and-Fertility-with-Elaine-Lopez-Bogard-e2onld5",

        description:
            "Elaine Lopez-Bogard discusses holistic healing, fertility, emotional wellness, trauma release, and remaining open to infinite possibilities."
    },


    {
        guid: "36088ca5-0c32-4c7a-a633-8dea8bb54c14",
        season: 1,
        episode: 3,

        title:
            "Acts of Kindness: Patricia Romero’s Journey of Faith and Community Impact",

        published:
            "2024-09-02",

        duration:
            "00:52:27",

        explicit: false,

        audioUrl:
            "https://anchor.fm/s/eff13fac/podcast/play/91175186/https%3A%2F%2Fd3ctxlq1ktw2nl.cloudfront.net%2Fstaging%2F2024-8-2%2F385677755-44100-2-77d4816291b6e.mp3",

        link:
            "https://podcasters.spotify.com/pod/show/felizgarcia/episodes/Acts-of-Kindness-Patricia-Romeros-Journey-of-Faith-and-Community-Impact-e2nsuqi",

        description:
            "Patricia Romero shares her journey of faith, kindness, community service, prayer, finding peace, and creating positive change through love."
    },


    {
        guid: "096483ce-4018-4abf-aa96-617c3e04de1a",
        season: 1,
        episode: 2,

        title:
            "Finding Your Light: Building Spiritual Communities with Paul Martinez",

        published:
            "2024-08-19",

        duration:
            "00:44:43",

        explicit: false,

        audioUrl:
            "https://anchor.fm/s/eff13fac/podcast/play/90591486/https%3A%2F%2Fd3ctxlq1ktw2nl.cloudfront.net%2Fstaging%2F2024-7-19%2F384960835-44100-2-420bdb518023e.mp3",

        link:
            "https://podcasters.spotify.com/pod/show/felizgarcia/episodes/Finding-Your-Light-Building-Spiritual-Communities-with-Paul-Martinez-e2nb4pu",

        description:
            "Feliz Garcia and Paul Martinez discuss spirituality, community, gratitude, patience, prayer, helping others, and finding personal purpose."
    },


    {
        guid: "a1df7566-07fd-4586-845d-121b1881afb0",
        season: 1,
        episode: 1,

        title:
            "Miraculous Stories: Cassandra Purdy's Testimony of Faith",

        published:
            "2024-08-04",

        duration:
            "00:54:08",

        explicit: true,

        audioUrl:
            "https://anchor.fm/s/eff13fac/podcast/play/90025718/https%3A%2F%2Fd3ctxlq1ktw2nl.cloudfront.net%2Fstaging%2F2024-7-4%2F384281164-44100-2-25e5f76521712.mp3",

        link:
            "https://podcasters.spotify.com/pod/show/felizgarcia/episodes/Miraculous-Stories-Cassandra-Purdys-Testimony-of-Faith-e2mps9m",

        description:
            "Cassandra Purdy shares her testimony of faith, transformation, resilience, and the miracles that shaped her journey."
    }

];